import { Static } from '@fastify/type-provider-typebox'
import { Type } from '@sinclair/typebox'
import { StatDateFrom, StatDateRange, StatDateTo } from '../seller-analytics'

// Revenue Schema
const RevenueCategory = Type.Object({
  amazonSales: Type.Number(),
  refunds: Type.Number(),
  reimbursements: Type.Number(),
  promoRebates: Type.Number(),
  otherRevenue: Type.Number(),
  totalRevenue: Type.Number()
})
type Revenue = Static<typeof RevenueCategory>

// Costs Schema
const CostsCategory = Type.Object({
  unitCost: Type.Number(),
  supplierShipping: Type.Number(),
  fbaInboundShipping: Type.Number(),
  orderFees: Type.Number(),
  miscellaneousCost: Type.Number(),
  totalCostOfGoodsSold: Type.Number()
})
type Costs = Static<typeof CostsCategory>

// Operating Expenses Schema
const OperatingExpenses = Type.Object({
  sellerFees: Type.Number(),
  salesTax: Type.Number(),
})
type OperatingExpense = Static<typeof OperatingExpenses>

// Period Data Schema
const PeriodData = Type.Object({
  dateRange: StatDateRange,
  revenue: RevenueCategory,
  costs: CostsCategory,
  operatingExpenses: OperatingExpenses,
  grossProfit: Type.Number(),
  grossMargin: Type.Number(),
  netProfit: Type.Number(),
  netMargin: Type.Number(),
})
type Period = Static<typeof PeriodData>

// Complete P&L Report Schema
const ProfitAndLossSchema = Type.Object({
  firstPeriod: PeriodData,
  secondPeriod: PeriodData,
  difference: PeriodData
})
type ProfitAndLoss = Static<typeof ProfitAndLossSchema>

const ProfitAndLossGetQueryString = Type.Object({
  firstFrom: StatDateFrom,
  firstTo: StatDateTo,
  secondFrom: StatDateFrom,
  secondTo: StatDateTo
})
type ProfitAndLossQuery = Static<typeof ProfitAndLossGetQueryString>

export {
  ProfitAndLossSchema,
  type ProfitAndLoss,
  RevenueCategory,
  type Revenue,
  CostsCategory,
  type Costs,
  OperatingExpenses,
  type OperatingExpense,
  PeriodData,
  type Period,
  ProfitAndLossGetQueryString,
  type ProfitAndLossQuery
}